import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['goCardless'];

export const goCardlessQueryKeys = {
  baseKey,
  checkStatus: [...baseKey, 'checkStatus'],
};
